import axios from '@fs/zion-axios'
import { VOLUNTEER_BASE_URL, headers } from '../config'

export async function getImageRecords(imageId) {
  const result = await axios.get(`${VOLUNTEER_BASE_URL}/sls/image/records/${imageId}`, { headers })
  return result.data
}
